import { com, Nullable } from '@eidu/form'
import FieldId = com.eidu.sharedlib.entity.field.FieldId
import FieldValue = com.eidu.sharedlib.entity.field.FieldValue
import LinkKey = com.eidu.sharedlib.entity.link.LinkKey
import ExternalValueKey = com.eidu.sharedlib.entity.user.ExternalValueKey

type Patch = {
  valuesToUpdateByFieldId: Map<FieldId, Nullable<FieldValue>>
  linksToUpdate: Map<LinkKey, Nullable<string>>
  externalValuesToUpdate: Map<ExternalValueKey, Nullable<string>>
}

export const hasModifications = (patch: Patch) =>
  patch.valuesToUpdateByFieldId.size > 0 || patch.linksToUpdate.size > 0 || patch.externalValuesToUpdate.size > 0

export default Patch
